module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "projects"
  }, [_vm._l((_vm.projects), function(project, key) {
    return _c('article', {
      key: key,
      staticClass: "project js-project",
      on: {
        "mouseenter": _vm.onProjectHover,
        "mouseleave": _vm.resetMousePos,
        "click": function($event) {
          return _vm.viewProject(project.slug)
        }
      }
    }, [_c('div', {
      staticClass: "project__body js-project-body"
    }, [_c('h1', {
      staticClass: "project__title"
    }, [_vm._v(_vm._s(project.title.rendered))]), _vm._v(" "), _c('h2', {
      staticClass: "projet__type"
    }, [_vm._v(_vm._s(project.category))])]), _vm._v(" "), _c('div', {
      staticClass: "project__thumbnail-wrapper"
    }, [_c('img', {
      staticClass: "project__thumbnail",
      class: project.CFS.thumbnailAlignement &&
        ("project__thumbnail--" + (project.CFS.thumbnailAlignement[0])),
      attrs: {
        "src": project.better_featured_image.source_url,
        "alt": project.title.rendered
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "projects__transition js-project-transition"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c683e84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProjectListView.vue
// module id = 175
// module chunks = 1